import React, { useState } from "react";
import { FiPlus, FiUpload } from "react-icons/fi";
import createFolder from "../../../services/Documents/Tree/createFolder";
import { LoaderCircle } from "lucide-react";

export const Top = ({
  breadcrumbs,
  navigateToFolder,
  currentParentId,
  items,
  uploadDocument,
  userId,
  updateTreeBranch,
  setSelectedItem,
  caseId,
}) => {
  const [newItemName, setNewItemName] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [isCreating, setIsCreating] = useState(false);

  const handleCreateFolder = async () => {
    if (!newItemName.trim() || !userId) {
      return;
    }

    try {
      setIsCreating(true);
      
      const response = await createFolder(
        userId,
        newItemName, 
        caseId,
        currentParentId
      );

      if (response && !response.error) {
        updateTreeBranch(currentParentId, true);
        
        setNewItemName("");
        setIsEditing(false);
      } else {
        console.error("Error creating folder:", response?.error);
      }
    } catch (error) {
      console.error("Error creating folder:", error);
    } finally {
      setIsCreating(false);
    }
  };

  const cancelEdit = () => {
    setNewItemName("");
    setIsEditing(false);
    setSelectedItem(null);
  };

  return (
    <>
      <div className="flex items-center mb-4 text-sm text-gray-600">
        {breadcrumbs.map((crumb, index) => (
          <div key={crumb.id || "home"} className="flex items-center">
            <span
              className={
                index < breadcrumbs.length - 1
                  ? "cursor-pointer hover:text-blue-600"
                  : "font-medium"
              }
              onClick={() =>
                index < breadcrumbs.length - 1
                  ? navigateToFolder(crumb.id)
                  : null
              }
            >
              {crumb.name ?? crumb.folderName}
            </span>
            {index < breadcrumbs.length - 1 && <span className="mx-2">/</span>}
          </div>
        ))}
      </div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-navy-900">
          {currentParentId === null
            ? "Carpetas"
            : items.find((x) => x._id === currentParentId)?.folderName ??
              "wrong"}
        </h1>

        <div className="flex space-x-2">
          {isEditing ? (
            <>
              <input
                type="text"
                value={newItemName}
                onChange={(e) => setNewItemName(e.target.value)}
                className="px-3 py-2 border rounded"
                placeholder="Nuevo nombre"
              />
              <button
                onClick={() => {}}
                className="px-4 py-2 bg-[#1A365D] text-white rounded hover:bg-indigo-800"
              >
                Guardar
              </button>
              <button
                onClick={cancelEdit}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
              >
                Cancelar
              </button>
            </>
          ) : (
            <>
              <input
                type="text"
                value={newItemName}
                onChange={(e) => setNewItemName(e.target.value)}
                placeholder="Nombre"
                className="px-3 py-2 border rounded"
              />
              <button
                onClick={handleCreateFolder}
                className="px-4 py-2 bg-[#1A365D] text-white rounded hover:bg-opacity-90 flex items-center"
                disabled={isCreating}
              >
                <FiPlus className="mr-1" /> Carpeta {isCreating && <LoaderCircle />}
              </button>
              <button
                onClick={uploadDocument}
                className="px-4 py-2 bg-[#B8860B] text-white rounded hover:bg-opacity-90 cursor-pointer flex items-center"
              >
                <FiUpload className="mr-1" /> Documento
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Top;
